import { render } from "./GameContent.vue?vue&type=template&id=e1e225a6"
import script from "./GameContent.vue?vue&type=script&lang=js"
export * from "./GameContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__